import '@lwc/synthetic-shadow';
import { createElement } from 'lwc';
import zPaperApp from 'zpaper/app';
// import help  from 'zpaper/help';
//import {version} from 'resources/version'; ORV240716 update version div in index.html

var intervalID = setInterval(function () {
    //Check to see if the promised has finished retrieving response from api server
    if (window.isApiCallbackFinished) {
        //callback to parent to inform of completion
        const app = createElement('zpaper-app', { is: zPaperApp });
        document.querySelector('#main').appendChild(app);
        //AHS250304 - ZP-988 - removing help component and replacing it with version in the bottom right (start)
        // if(!window.__g_isMobile){
        //     const helpCmp = createElement('zpaper-help', {is: help});
        //     document.querySelector('.version').appendChild(helpCmp);
        // }
        //AHS250304 - ZP-988 - removing help component and replacing it with version in the bottom right (end)
        // document.querySelector('.version').innerHTML = "v" + version; ORV240716 update version div in index.html
        // window.sprzVersion = version;
        //stop polling
        
        clearInterval(intervalID);
    }
}, 250, this); 